import { consts } from './consts'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function parseCookie(str: string) {
  return str
    .split(';')
    .map((x) => x.split('='))
    .reduce((acc, x) => {
      if (x.length !== 2) return acc
      acc[decodeURIComponent(x[0].trim())] = decodeURIComponent(x[1].trim())
      return acc
    }, {} as Record<string, string>)
}

export function extractAuthenticationCookie(cookies: Record<string, string>): string | null {
  if (!cookies) return null

  const webClientCookieName = cookies[consts.WebClientCookieName]
  if (!webClientCookieName) return null

  const clientIdCookieParameter = parseCookie(webClientCookieName)[consts.ClientIdCookieParameter]
  if (!clientIdCookieParameter) return null

  return clientIdCookieParameter
}
